import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconWebchat",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.842 1.342c.219-.22.515-.342.825-.342h4.666A1.167 1.167 0 0 1 11.5 2.167v4.73a.75.75 0 0 1-1.28.53l-.687-.687a.25.25 0 0 0-.177-.073H8.5V8a1.167 1.167 0 0 1-1.167 1.167H3.644a.25.25 0 0 0-.177.073l-.687.687a.75.75 0 0 1-1.28-.53v-4.73A1.167 1.167 0 0 1 2.667 3.5H4.5V2.167c0-.31.123-.606.342-.825ZM5.5 3.5h1.833A1.167 1.167 0 0 1 8.5 4.667v1h.856c.332 0 .65.131.884.366l.26.26V2.167A.167.167 0 0 0 10.333 2H5.667a.167.167 0 0 0-.167.167V3.5Zm5.427 3.22ZM7.5 4.667a.167.167 0 0 0-.167-.167H2.667a.167.167 0 0 0-.167.167v4.126l.26-.26a1.25 1.25 0 0 1 .884-.366h3.69A.167.167 0 0 0 7.5 8V4.667Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _
];
function m(e, u, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--webchat"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Webchat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, h, 10, c);
}
const A = /* @__PURE__ */ o(s, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=webchat.js.map
